export default __webpack_public_path__ + "static/media/shopify_connect-3.ea16de0f.svg";